<template>
  <VueShowdown
    v-bind="$attrs"
    class="Markdown"
    :class="{ PageStyling: hasStyles }"
    :markdown="markdown" />
</template>

<script>
import '../mixins/PageStyling'
import Vue from 'vue'
import VueShowdown from 'vue-showdown'

Vue.use(VueShowdown, {
  options: {
    tables: true,
  },
})

export default {
  props: {
    hasStyles: Boolean,
    markdown: String,
  },
}
</script>

<style lang="scss">
</style>
